<template>
  <div>
    <ContentHeader :show-back="false" />

    <div class="content-wrapper">
      <el-row >
        <el-col :span="7" class="content-left">
          <UserNavPanel />
        </el-col>

        <el-col :span="17" class="content-right">
          <router-view />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import UserNavPanel from './components/user-nav-panel'
export default {
  name: 'account-info',
  components: {
    ContentHeader,
    UserNavPanel
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
</style>
